import {ADDRESS_SEARCH_REQUEST, ADDRESS_SEARCH_RESPONSE} from '../actions/address.actions';

export default function address(state = {searchResult: []}, action) {
  switch (action.type) {
    case ADDRESS_SEARCH_REQUEST: {
      let nextState = {...state};
      nextState.searchResult = [];
      return state;
    }
    case ADDRESS_SEARCH_RESPONSE: {
      let nextState = {...state};
      if (action.searchResult) {
        nextState.searchResult = action.searchResult;
      }
      return nextState;
    }
  }
  return state;
}
